import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '../base.service';
import { httpParams } from '../http-params.builder';

@Injectable({
  providedIn: 'root',
})
export class AiService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  getChatkitUploadUrl(projectId?: string): string {
    const params = httpParams().set('projectId', projectId).build().toString();
    return `${this.baseUrl}/ai/upload/file${params ? `?${params}` : ''}`;
  }

  getChatkitApiUrl(): string {
    return `${this.baseUrl}/ai`;
  }

  uploadProjectDocumentFile(fileId: string): Observable<Record<string, unknown>> {
    return this.http.post<Record<string, unknown>>(`${this.baseUrl}/ai/upload/document-file`, { fileId });
  }

  cleanupChatkitThreadUploads(threadId: string): Observable<Record<string, unknown>> {
    return this.http.post<Record<string, unknown>>(`${this.baseUrl}/ai/threads/${threadId}/uploads/cleanup`, {});
  }
}
